import React from 'react'
import { useStoreState } from 'easy-peasy'
import components from '../components/common'

export default function Landing() {
  const [
    { finalComponents },
    score,
    coupon,
  ] = useStoreState(state => [
    state.landing.landing,
    state.quiz.score,
    state.quiz.coupon,
  ])

  return (
    <>
      {finalComponents.map((item, i) => {
        const TypeComponent = components[item.type]
        return (
          <TypeComponent
            // eslint-disable-next-line react/no-array-index-key
            key={`component-${item.type}-${i}`}
            config={item.config}
            score={score}
            coupon={coupon}
          />
        )
      })}
    </>
  )
}
